import axios from 'axios';
import {getPostHeaders} from './headers';
import {RESOURCES as orderResources} from '../orderResources';

// The reason a failed request gives. This endpoint's `error` names what was
// refused (the ids, the status) and its `message` is generic, so `error`
// comes first, unlike apiFunctions' failureMessage. Empty strings are skipped:
// over HTTP/2 a browser's statusText is always ''.
const failureReason = (error) => {
    const response = error?.response;
    const reason = response?.data?.error || response?.data?.message || response?.statusText || error?.message;
    if (reason) {
        return reason;
    }
    return (response) ? `HTTP ${response.status}` : 'no response from the server';
};

/**
 * Set one status on a selection of orders in a single request
 * (parrot-media/portal/main#322). The API changes all of them or none: if any
 * id is not a created order, nothing moves and the reason names those ids.
 * Rejects with an Error whose message is the server's reason, so the caller
 * can show it as it is.
 *
 * @param orderIds
 * @param statusId
 * @return {Promise<{status_id: number, order_ids: number[]}>}
 */
export const putOrdersStatus = async (orderIds, statusId) => {
    const cfg = orderResources.OrdersUpdateStatus.UPDATE({order_ids: orderIds, status_id: statusId});
    try {
        const result = await axios({
            method: cfg.method,
            url: cfg.uri,
            data: cfg.data,
            headers: getPostHeaders(true)
        });
        return result.data;
    } catch (error) {
        throw new Error(failureReason(error));
    }
};
